import { render, staticRenderFns } from "./DealWorkflowChain.vue?vue&type=template&id=1c8877c3&scoped=true"
import script from "./DealWorkflowChain.vue?vue&type=script&lang=js"
export * from "./DealWorkflowChain.vue?vue&type=script&lang=js"
import style0 from "./DealWorkflowChain.vue?vue&type=style&index=0&id=1c8877c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8877c3",
  null
  
)

export default component.exports